<template>
  <div>
    <div class="title1">
      {{ $t("info_card.undergraduate_education_history") }}
    </div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGGrad_universityStudyStatusId"
          v-bind:label="$t('info_card.university_study_status')"
          v-bind:item-text="
            (item) => objectTranslator(item, 'UNIVERSITY_STUDY_STATUS_NAME')
          "
          v-bind:items="universityStudyStatuss"
          v-bind:item-value="(item) => item.UNIVERSITY_STUDY_STATUS_ID"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
    </v-row>
    <div class="title2">
      {{ $t("info_card.university_location") }}
    </div>
    <ThaiOrForeignCountry
      v-model="EducationBGGrad_universityLocation"
      v-bind:rules="requiredRules"
    />
    <v-row v-if="this.EducationBGGrad_universityLocation === 'inThai'">
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGGrad_universityId"
          v-bind:label="$t('info_card.university_name')"
          v-bind:item-text="(item) => objectTranslator(item, 'UNIVERSITY_NAME')"
          v-bind:items="universitys"
          v-bind:item-value="(item) => item.UNIVERSITY_ID"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4"> {{ $t("info_card.add_university") }}</v-col>
    </v-row>
    <v-row v-if="this.EducationBGGrad_universityLocation === 'foreignCountry'">
      <v-col cols="12" sm="4">
        <CountryCard
          v-model="EducationBGGrad_countryIdOfUniversity"
          v-bind:rules="requiredRules"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_universityName"
          v-bind:label="$t('info_card.university_name')"
          v-bind:hint="$t('info_card.university_name')"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_graduatedYear"
          v-bind:label="$t('info_card.graduated_year')"
          type="number"
          outlined
          dense
          v-bind:rules="yearRules"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="EducationBGGrad_degreeName"
          v-bind:label="$t('info_card.degree_name')"
          v-bind:hint="$t('info_card.degree_name')"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_curriculumName"
          v-bind:label="$t('info_card.curriculum_name')"
          v-bind:hint="$t('info_card.curriculum_name')"
          v-bind:rules="requiredRules"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <GpaCard
          v-model="EducationBGGrad_GPA"
          v-bind:textLabel="$t('info_card.GPA')"
          v-bind:textHint="$t('info_card.GPA_hint')"
        />
      </v-col>
    </v-row>
    <!-- ---------------------- Master ----------------------------- -->
    <div class="title1">
      {{ $t("info_card.graduate_education_history") }}
    </div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGGrad_masterUniversityStudyStatusId"
          v-bind:label="$t('info_card.university_study_status')"
          v-bind:item-text="
            (item) => objectTranslator(item, 'UNIVERSITY_STUDY_STATUS_NAME')
          "
          v-bind:items="universityStudyStatuss"
          v-bind:item-value="(item) => item.UNIVERSITY_STUDY_STATUS_ID"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
    </v-row>
    <div class="title2">
      {{ $t("info_card.university_location") }}
    </div>
    <ThaiOrForeignCountry v-model="EducationBGGrad_masterUniversityLocation" />
    <v-row v-if="this.EducationBGGrad_masterUniversityLocation === 'inThai'">
      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="EducationBGGrad_masterUniversityId"
          v-bind:label="$t('info_card.university_name')"
          v-bind:item-text="(item) => objectTranslator(item, 'UNIVERSITY_NAME')"
          v-bind:items="universitys"
          v-bind:item-value="(item) => item.UNIVERSITY_ID"
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4"> {{ $t("info_card.add_university") }}</v-col>
    </v-row>
    <v-row
      v-if="this.EducationBGGrad_masterUniversityLocation === 'foreignCountry'"
    >
      <v-col cols="12" sm="4">
        <CountryCard v-model="EducationBGGrad_masterCountryIdOfUniversity" />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_masterUniversityName"
          v-bind:label="$t('info_card.university_name')"
          v-bind:hint="$t('info_card.university_name')"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_masterGraduatedYear"
          v-bind:label="$t('info_card.graduated_year')"
          type="number"
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="EducationBGGrad_masterDegreeName"
          v-bind:label="$t('info_card.degree_name')"
          v-bind:hint="$t('info_card.degree_name')"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_masterCurriculumName"
          v-bind:label="$t('info_card.curriculum_name')"
          v-bind:hint="$t('info_card.curriculum_name')"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_masterGPA"
          v-bind:label="$t('info_card.GPA')"
          v-bind:hint="$t('info_card.GPA_hint')"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- ---------------------- Working Experience ----------------------------- -->
    <div class="title2">
      {{ $t("info_card.graduate_working_experience") }}
    </div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_numOfYearWorking"
          v-bind:label="$t('info_card.num_year_working_experience')"
          type="number"
          outlined
          dense
        />
      </v-col>
    </v-row>
    <!-- --------------- company 1 ---------------------- -->
    <v-row>
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="EducationBGGrad_companyName"
          v-bind:label="$t('info_card.company_name')"
          v-bind:hint="$t('info_card.company_name')"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_sinceWorking"
          v-bind:label="$t('info_card.since_working')"
          type="number"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_positionInCompany"
          v-bind:label="$t('info_card.position_in_company')"
          v-bind:hint="$t('info_card.position_in_company')"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- --------------- company 2 ---------------------- -->
    <v-row>
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="EducationBGGrad_companyName1"
          v-bind:label="$t('info_card.company_name1')"
          v-bind:hint="$t('info_card.company_name1')"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_sinceWorking1"
          v-bind:label="$t('info_card.since_working')"
          type="number"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="EducationBGGrad_positionInCompany1"
          v-bind:label="$t('info_card.position_in_company')"
          v-bind:hint="$t('info_card.position_in_company')"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ThaiOrForeignCountry from "./ThaiOrForeignCountry";
import CountryCard from "./Country";
import GpaCard from "./GPA";
import { objectTranslator } from "../../helper/translator";
import validator from "@/helper/validator";

export default {
  name: "EducationBackgroundGradInfoCard",
  props: [
    "value_universityLocation",
    "value_countryIdOfUniversity",
    "value_universityName",
    "value_universityId",
    "value_universityStudyStatusId",
    "value_graduatedYear",
    "value_degreeName",
    "value_curriculumName",
    "value_GPA",
    //---------------------- Master -----------------------------

    "value_masterUniversityLocation",
    "value_masterCountryIdOfUniversity",
    "value_masterUniversityName",
    "value_masterUniversityId",
    "value_masterUniversityStudyStatusId",
    "value_masterGraduatedYear",
    "value_masterDegreeName",
    "value_masterCurriculumName",
    "value_masterGPA",
    //--------------------- Working Experience -------------------
    "value_numOfYearWorking",
    "value_companyName",
    "value_sinceWorking",
    "value_positionInCompany",
    "value_companyName1",
    "value_sinceWorking1",
    "value_positionInCompany1",
  ],
  data: function() {
    return {
      yearRules: [validator.required, validator.thaiYear],
      requiredRules: [validator.required],
    };
  },
  components: {
    ThaiOrForeignCountry,
    CountryCard,
    GpaCard,
  },

  methods: {
    objectTranslator,
  },
  computed: {
    universitys: function() {
      return this.$store.state.ref.universitys;
    },
    universityStudyStatuss: function() {
      return this.$store.state.ref.universityStudyStatuss;
    },
    EducationBGGrad_universityStudyStatusId: {
      get() {
        return this.value_universityStudyStatusId;
      },
      set(value) {
        this.$emit("input_universityStudyStatusId", value);
      },
    },
    EducationBGGrad_universityLocation: {
      get() {
        return this.value_universityLocation;
      },
      set(value) {
        this.$emit("input_universityLocation", value);
      },
    },
    EducationBGGrad_universityId: {
      get() {
        return this.value_universityId;
      },
      set(value) {
        this.$emit("input_universityId", value);
      },
    },
    EducationBGGrad_countryIdOfUniversity: {
      get() {
        return this.value_countryIdOfUniversity;
      },
      set(value) {
        this.$emit("input_countryIdOfUniversity", value);
      },
    },
    EducationBGGrad_universityName: {
      get() {
        return this.value_universityName;
      },
      set(value) {
        this.$emit("input_universityName", value);
      },
    },
    EducationBGGrad_graduatedYear: {
      get() {
        return this.value_graduatedYear;
      },
      set(value) {
        this.$emit("input_graduatedYear", value);
      },
    },
    EducationBGGrad_degreeName: {
      get() {
        return this.value_degreeName;
      },
      set(value) {
        this.$emit("input_degreeName", value);
      },
    },
    EducationBGGrad_curriculumName: {
      get() {
        return this.value_curriculumName;
      },
      set(value) {
        this.$emit("input_curriculumName", value);
      },
    },
    EducationBGGrad_GPA: {
      get() {
        return this.value_GPA;
      },
      set(value) {
        this.$emit("input_GPA", value);
      },
    },

    //---------------------- Master -----------------------------
    EducationBGGrad_masterUniversityStudyStatusId: {
      get() {
        return this.value_masterUniversityStudyStatusId;
      },
      set(value) {
        this.$emit("input_masterUniversityStudyStatusId", value);
      },
    },
    EducationBGGrad_masterUniversityLocation: {
      get() {
        return this.value_masterUniversityLocation;
      },
      set(value) {
        this.$emit("input_masterUniversityLocation", value);
      },
    },
    EducationBGGrad_masterUniversityId: {
      get() {
        return this.value_masterUniversityId;
      },
      set(value) {
        this.$emit("input_masterUniversityId", value);
      },
    },
    EducationBGGrad_masterCountryIdOfUniversity: {
      get() {
        return this.value_masterCountryIdOfUniversity;
      },
      set(value) {
        this.$emit("input_masterCountryIdOfUniversity", value);
      },
    },
    EducationBGGrad_masterUniversityName: {
      get() {
        return this.value_masterUniversityName;
      },
      set(value) {
        this.$emit("input_masterUniversityName", value);
      },
    },
    EducationBGGrad_masterGraduatedYear: {
      get() {
        return this.value_masterGraduatedYear;
      },
      set(value) {
        this.$emit("input_masterGraduatedYear", value);
      },
    },
    EducationBGGrad_masterDegreeName: {
      get() {
        return this.value_masterDegreeName;
      },
      set(value) {
        this.$emit("input_masterDegreeName", value);
      },
    },
    EducationBGGrad_masterCurriculumName: {
      get() {
        return this.value_masterCurriculumName;
      },
      set(value) {
        this.$emit("input_masterCurriculumName", value);
      },
    },
    EducationBGGrad_masterGPA: {
      get() {
        return this.value_masterGPA;
      },
      set(value) {
        this.$emit("input_masterGPA", value);
      },
    },
    //---------------------- Working Experience -----------------------------
    EducationBGGrad_numOfYearWorking: {
      get() {
        return this.value_numOfYearWorking;
      },
      set(value) {
        this.$emit("input_numOfYearWorking", value);
      },
    },
    EducationBGGrad_companyName: {
      get() {
        return this.value_companyName;
      },
      set(value) {
        this.$emit("input_companyName", value);
      },
    },
    EducationBGGrad_sinceWorking: {
      get() {
        return this.value_sinceWorking;
      },
      set(value) {
        this.$emit("input_sinceWorking", value);
      },
    },
    EducationBGGrad_positionInCompany: {
      get() {
        return this.value_positionInCompany;
      },
      set(value) {
        this.$emit("input_positionInCompany", value);
      },
    },
    EducationBGGrad_companyName1: {
      get() {
        return this.value_companyName1;
      },
      set(value) {
        this.$emit("input_companyName1", value);
      },
    },
    EducationBGGrad_sinceWorking1: {
      get() {
        return this.value_sinceWorking1;
      },
      set(value) {
        this.$emit("input_sinceWorking1", value);
      },
    },
    EducationBGGrad_positionInCompany1: {
      get() {
        return this.value_positionInCompany1;
      },
      set(value) {
        this.$emit("input_positionInCompany1", value);
      },
    },
  },
  mounted: function() {
    this.$store.dispatch("ref/getUniversitys");
    this.$store.dispatch("ref/getUniversityStudyStatuss");
  },
};
</script>
<style scoped>
.title1 {
  /* color: purple; */
  text-decoration: underline;
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.title2 {
  font-size: 20px;
  margin-bottom: 20px;
}
</style>
